import { doc, setDoc } from "firebase/firestore";
import { db } from "../lib/firebase";
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from 'react';
import { Typography, Button, Box, Container } from '@mui/material';
import backgroundImage from '../assets/bg.jpg';
import './LandingPage.css';
import TemporaryDrawer from "../components/drawer";

function History() {
  const navigate = useNavigate();

  // Fade in effects
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  // Generate unique string
  function generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0,
      v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  // Generate room with unique link
  const handleCreateRoom = async () => {
    const UUID = generateUUID();
    await setDoc(doc(db, "rooms", UUID), {
      messages: []
    });
    navigate('/chat/' + UUID);
  };

  return (
    <Container
      sx={{
        minWidth: '100vw',
        minHeight: '100vh',
        overflow: 'hidden',
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'bottom center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: -1,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center', // Center the content vertically
          textAlign: 'center',       // Center the text
          width: '80%',              // Adjust width as needed
          maxWidth: '600px',         // Optional max width
        }}
      >
        <Typography
          variant="h5"
          className="header"
          sx={{
            mb: 4,
            color: 'white',
            opacity: visible ? 1 : 0,
            transition: 'opacity 1s 0.3s',
            fontSize: '1.25rem', // Adjust font size as needed
          }}
        >
          We know how isolating it can be to face challenges alone, feeling too scared or embarrassed to reach out, even when you need support the most. The loneliness that comes from having no one to talk to is something we deeply understand. That's why we're here to provide an anonymous, unbiased, and non-judgmental space where you can find the support you need.
        </Typography>
        <Button
          variant="outlined"
          size="large"
          className="header"
          sx={{
            opacity: visible ? 1 : 0,
            transform: `translateY(${visible ? 0 : '1rem'})`,
            transition: 'opacity 1s 0.6s, transform 1s 0.5s',
            borderColor: 'white',
            textTransform: 'none',
            borderRadius: '20px',
            color: 'white',
            fontWeight: 'bold',
            padding: '10px 20px',
            '&:hover': {
              transition: '0.5s',
              color: 'white',
              borderColor: 'white',
              transform: 'scale(1.05)',
              backgroundColor: 'transparent',
            },
          }}
          onClick={handleCreateRoom}
        >
          chat to us now
        </Button>
      </Box>
      <TemporaryDrawer />
    </Container>
  );
}

export default History;
